<script lang="ts">
  import CartButton from "./components/CartButton.svelte";
  import Overlay from "./components/Overlay.svelte";
  import Cart from "./components/Cart.svelte";
  import { onMount } from "svelte";
  import cart, { toggleCart } from "./stores/cart";
  import Portal from "svelte-portal/src/Portal.svelte";
  import OrderForm from "./components/OrderForm.svelte";
  import ButtonSpinner from "./components/ButtonSpinner.svelte";

  let buyButtonRef: HTMLButtonElement;
  let orderFormRef: HTMLElement;
  let isLoading = false;

  function initBuyButton() {
    const cartForm = document.querySelector<HTMLFormElement>("form.cart");
    if (!cartForm) {
      return;
    }
    buyButtonRef = cartForm.querySelector<HTMLButtonElement>("[type='submit']");
    buyButtonRef.style.position = "relative";
    cartForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const formData = new FormData(cartForm);
      formData.append(buyButtonRef.name, buyButtonRef.value);
      buyButtonRef.setAttribute("disabled", "true");
      isLoading = true;
      const res = await fetch(cartForm.action, {
        method: "POST",
        body: formData,
      });
      if (res.ok) {
        await cart.fetch();
        toggleCart(true);
      } else {
        console.error(res);
      }
      buyButtonRef.removeAttribute("disabled");
      isLoading = false;
    });
  }

  function initOrderForm() {
    orderFormRef = document.querySelector<HTMLFormElement>("#order-form");
  }

  onMount(() => {
    initBuyButton();
    initOrderForm();
  });
</script>

<main>
  <CartButton />
  <Overlay />
  <Cart />

  {#if buyButtonRef && isLoading}
    <Portal target={buyButtonRef}>
      <ButtonSpinner />
    </Portal>
  {/if}

  {#if orderFormRef}
    <Portal target={orderFormRef}>
      <OrderForm />
    </Portal>
  {/if}
</main>

<style global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
</style>
